module.exports = import("https://esm.sh/@tiptap/extension-text@2.4.0");;